/**
 * Created by rathompson on 8/16/23
 * File: FeatureNotSupportedScreen.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import NoDataScreen from '../noDataScreen/NoDataScreen'
import { InvalidPermissionsSVG } from '@panwds/react-ui'
import {
  TITLE_FEATURE_NOT_SUPPORTED,
  SUBTITLE_FEATURE_NOT_SUPPORTED
} from '../../constants/LabelConstants'

const RestrictedAccessScreen: VFC<any> = () => {
  return (
    <div className='cm-flex cm-flex-row cm-flex-1 cm-w-full cm-h-full'>
      <NoDataScreen
        style={{ height: '100%', width: '100%' }}
        graphic={<InvalidPermissionsSVG width={90} height={90} />}
        heading={TITLE_FEATURE_NOT_SUPPORTED}
        description={SUBTITLE_FEATURE_NOT_SUPPORTED}
      />
    </div>
  )
}

export default RestrictedAccessScreen
